"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLICY_NUMBER_PREFIX_MAP = void 0;
exports.POLICY_NUMBER_PREFIX_MAP = {
    HOME: ["FLH"],
    WOLF_MOTOR: ["FLO", "BRI"],
};
//# sourceMappingURL=policyHelper.js.map